import { useState } from 'react';

import PrivateCodeForm from '../../../PrivateCodeForm';
import { StepProps, StepsId } from '../../types';
import { useMultiTierCheckout } from '../../context';
import { getVerifyCode } from '../../../../../hooks';

import styles from '../../../Checkout.module.scss';

const PrivateCodeStep = ({ goToStep }: StepProps) => {
  const [formErrorMessage, setFormErrorMessage] = useState(null);
  const {
    data: {
      isLoading,
      specialCode,
      ticketTiers,
      tickets,
      event,
      appliedDiscount
    },
    toggleTicketTierAndSave,
    applyDiscountCodeAndSave
  } = useMultiTierCheckout();

  const goToTicketsSelection = () => {
    specialCode.code.setCode(null);
    goToStep(StepsId.TicketsSelectionStep);
  };

  const onSetCode = (code: string) => {
    setFormErrorMessage(null);
    specialCode.code.setCode(code);
  };

  /**
   * Callback function called when special private code (discount code or private tier unlock code) is successfully verified.
   */
  const onVerifyCodeSuccess = (data) => {
    if (data.type === 'discountCode' || data.type === 'promoterAttribution') {
      if (Object.keys(ticketTiers.privateTierCodes).length > 0) {
        setFormErrorMessage(
          'You cannot apply discount codes to private tiers.'
        );
        return;
      }

      if (Object.keys(tickets.selectedTicketTiers).length === 0) {
        specialCode.discountCode.applyDiscountCode(specialCode.code.value);
      } else {
        applyDiscountCodeAndSave(specialCode.code.value);
      }

      goToTicketsSelection();
    } else if (data.type === 'privateTier') {
      if (appliedDiscount?.data?.code) {
        setFormErrorMessage(
          'You cannot apply discount codes to private tiers.'
        );
        return;
      }

      if (ticketTiers.isCodeAlreadyActive(specialCode.code.value)) {
        setFormErrorMessage('Private code has already been unlocked.');
        return;
      }

      ticketTiers.unlockPrivateTier(specialCode.code.value, {
        onSuccess: (unlockedTier) => {
          if (!ticketTiers.isTierDisabled(unlockedTier.tierId)) {
            if (ticketTiers.isTierRequiringApproval(unlockedTier.tierId)) {
              tickets.toggleTierRequiringApproval(unlockedTier.tierId);
            } else {
              toggleTicketTierAndSave(
                unlockedTier.tierId,
                specialCode.code.value
              );
            }
          }
          goToTicketsSelection();
        }
      });
    }
  };

  /**
   * Verifies the provided special code whenever it updates.
   */
  const verifiedCodeData = getVerifyCode(event._id, specialCode.code.value, 1, {
    onSuccess: onVerifyCodeSuccess
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.column}>
        <div className="px-5">
          <PrivateCodeForm
            onGoBack={goToTicketsSelection}
            onUnlock={onSetCode}
            title={null}
            isLoading={isLoading}
            errorMessage={
              ticketTiers.getTierFromShareTokenError?.message ||
              verifiedCodeData.error?.message ||
              formErrorMessage
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PrivateCodeStep;
